import { useEffect, useState } from 'react'
import { ShoppingBag, Package, Users, DollarSign, RefreshCw } from 'lucide-react'

interface ShopifyData {
  orders: number
  revenue: number
  customers: number
  products: number
  recentOrders: Array<{
    id: string
    customer: string
    total: number
    status: string
    date: string
  }>
}

export default function ShopifyPage() {
  const [data, setData] = useState<ShopifyData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchShopifyData()
  }, [])

  const fetchShopifyData = async () => {
    setLoading(true)
    // TODO: Implementar chamada real à API do Shopify
    // Por enquanto, dados mockados
    setTimeout(() => {
      setData({
        orders: 0,
        revenue: 0,
        customers: 0,
        products: 0,
        recentOrders: []
      })
      setLoading(false)
    }, 1000)
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Shopify</h1>
          <p className="text-gray-600 mt-1">Gestão de encomendas e produtos</p>
        </div>
        <button
          onClick={fetchShopifyData}
          className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition"
        >
          <RefreshCw className="w-4 h-4" />
          Atualizar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Encomendas</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.orders || 0}</p>
            </div>
            <ShoppingBag className="w-8 h-8 text-blue-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Receita</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">€{data?.revenue.toFixed(2) || '0.00'}</p>
            </div>
            <DollarSign className="w-8 h-8 text-green-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Clientes</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.customers || 0}</p>
            </div>
            <Users className="w-8 h-8 text-purple-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Produtos</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.products || 0}</p>
            </div>
            <Package className="w-8 h-8 text-orange-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Encomendas Recentes</h2>
        </div>
        <div className="p-6">
          {data?.recentOrders.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Nenhuma encomenda encontrada</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-gray-600 border-b">
                    <th className="pb-3">ID</th>
                    <th className="pb-3">Cliente</th>
                    <th className="pb-3">Total</th>
                    <th className="pb-3">Status</th>
                    <th className="pb-3">Data</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.recentOrders.map((order) => (
                    <tr key={order.id} className="border-b">
                      <td className="py-3">{order.id}</td>
                      <td className="py-3">{order.customer}</td>
                      <td className="py-3">€{order.total.toFixed(2)}</td>
                      <td className="py-3">
                        <span className="px-2 py-1 bg-gray-100 text-black rounded text-sm">
                          {order.status}
                        </span>
                      </td>
                      <td className="py-3">{order.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
